import { createBrowserRouter } from "react-router-dom";
import App from "./App";

/** Data router required for `useBlocker` (unsaved-changes guards). */
export const appRouter = createBrowserRouter([
  {
    path: "*",
    element: <App />,
  },
]);
